export const AccessType = {
    STRATEGY_CENTER: 'strategyCenter',
    DATA_REPORT: 'dataReport',
    SUBID: 'subid',
    SINGLE_END_LOG: 'singleEndLog',
    // 日志报表已改名为双端流量 logReport -> doubleEndLog
    DOUBLE_END_LOG: 'logReport',
    LOG_REPORT: 'logReport',
    INTELLIGENCE: 'intelligence',
    API_SERVER_MONITOR: 'apiServerMonitor',
    BUSINESS_ANALYSE_GENERAGE: 'businessAnalyseGenerage'
};